<div class="chat-widget" [class.chat-open]="isOpen">
  <div class="chat-popup" *ngIf="isOpen">
    <div class="chat-head">
      <div class="chat-agent">
        <div class="agent-avatar">
          <span>ATW</span>
          <i></i>
        </div>

        <div>
          <strong>{{ 'atw.chat.title' | transloco }}</strong>
          <p>
            <span class="online-dot"></span>
            {{ 'atw.chat.online' | transloco }}
          </p>
        </div>
      </div>

      <button
        type="button"
        class="chat-close"
        (click)="closeChat()"
        aria-label="Close chat"
      >
        ×
      </button>
    </div>

    <div class="chat-body" #chatBody>
      <div class="chat-intro-card">
        <span>👋</span>
        <div>
          <strong>{{ 'atw.chat.introTitle' | transloco }}</strong>
          <p>{{ 'atw.chat.introText' | transloco }}</p>
        </div>
      </div>

      <div class="chat-messages">
        <div
          class="chat-message"
          *ngFor="let message of messages"
          [class.user-message]="message.sender_type === 'user'"
          [class.bot-message]="message.sender_type !== 'user'"
        >
          <div class="message-bubble">
            <p>
              {{
                message.message_key
                  ? (message.message_key | transloco)
                  : message.message
              }}
            </p>

            <small>{{ message.time }}</small>
          </div>
        </div>

        <div class="chat-message bot-message" *ngIf="isTyping">
          <div class="message-bubble typing-bubble">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      <div class="quick-replies">
        <button
          type="button"
          *ngFor="let item of quickReplies"
          (click)="sendQuickMessage(item.message_key)"
          [disabled]="isSending"
        >
          <span>{{ item.icon }}</span>
          {{ item.label_key | transloco }}
        </button>
      </div>
    </div>

    <div class="chat-footer">
      <div class="chat-input">
        <input
          type="text"
          [value]="draftMessage"
          (input)="getInputValue($event)"
          (keydown.enter)="sendMessage()"
          [disabled]="isSending"
          [placeholder]="'atw.chat.placeholder' | transloco"
        />

        <button
          type="button"
          class="send-btn"
          (click)="sendMessage()"
          [disabled]="!draftMessage.trim() || isSending"
        >
                  <img class="img-m" src="assets/as/29.webp" alt="search" />
        </button>
      </div>

      <button type="button" class="whatsapp-btn" (click)="openWhatsapp()">
        <span>☎</span>
        {{ 'atw.chat.whatsapp' | transloco }}
      </button>
    </div>
  </div>

  <button
    type="button"
    class="chat-floating-btn"
    (click)="toggleChat()"
    [class.has-notification]="unreadCount > 0"
    aria-label="Open chat"
  >
    <span class="chat-icon" *ngIf="!isOpen">💬</span>
    <span class="chat-icon" *ngIf="isOpen">×</span>

    <small *ngIf="unreadCount > 0">
      {{ unreadCount }}
    </small>

    <i></i>
  </button>
</div>
